/* ================================================================
   LIVEFASTCULTURE — GLOBAL ERROR HANDLER  (CP31)
   Loaded first in <head> on every page — before any other script.

   FEATURES:
   1. Catches uncaught JS errors + unhandled promise rejections.
   2. window.__LFJ_ERRORS — circular buffer, last 20 entries.
      Each: { kind, msg, src, line, col, stack, time }
   3. Repeated-error grouping — same src:line firing 3+ times in
      10 s collapses to one console.warn, suppresses duplicates.
   4. Debug HUD — fixed bottom-left overlay with last 5 errors.
      Activate: window.LFJ_DEBUG = true  (live in browser console)
      OR set Theme Setting debug_mode_enabled = true (off by default).
      Toggle live — setter shows/hides HUD immediately.

   NEVER shows anything to real visitors. Never auto-repairs.
================================================================ */
(function () {
  if (window.__lfErrorHandlerInit) return;
  window.__lfErrorHandlerInit = true;

  var LABEL   = '[LFJ]';
  var MAX_BUF = 20;
  var RPT_WIN = 10000; /* ms window for repeat detection */
  var RPT_MIN = 3;     /* occurrences before grouping */

  /* ── Circular buffer ─────────────────────────────────────── */
  window.__LFJ_ERRORS = [];
  var _seen = {}; /* key = "src:line" → [timestamps] */

  function _push(entry) {
    var buf = window.__LFJ_ERRORS;
    buf.push(entry);
    if (buf.length > MAX_BUF) buf.shift();
    _maybeUpdateHUD();
  }

  function _isRepeat(key) {
    var now = Date.now();
    var arr = _seen[key] || (_seen[key] = []);
    _seen[key] = arr = arr.filter(function(t){ return now - t < RPT_WIN; });
    arr.push(now);
    return arr.length >= RPT_MIN;
  }

  function _log(kind, detail, key) {
    var entry = {
      kind:  kind,
      msg:   detail && (detail.message || String(detail)),
      src:   detail && detail.source,
      line:  detail && detail.line,
      col:   detail && detail.col,
      stack: detail && detail.stack,
      time:  Date.now()
    };
    _push(entry);
    if (key && _isRepeat(key)) {
      try { console.warn(LABEL + ' [repeated x' + RPT_MIN + ' in 10s] ' + (entry.msg || kind), entry.src || ''); } catch(e){}
      return;
    }
    try { console.error(LABEL + ' ' + kind, detail); } catch(e){}
  }

  /* ── Listeners ───────────────────────────────────────────── */
  window.addEventListener('error', function(ev) {
    _log('Uncaught error', {
      message: ev.message, source: ev.filename,
      line: ev.lineno, col: ev.colno,
      stack: ev.error && ev.error.stack
    }, (ev.filename||'') + ':' + (ev.lineno||''));
  }, true);

  window.addEventListener('unhandledrejection', function(ev) {
    var r = ev.reason;
    _log('Unhandled rejection', {
      message: r && (r.message || String(r)),
      stack:   r && r.stack
    }, null);
  });

  /* ── Debug HUD ───────────────────────────────────────────── */
  var _hud = null;

  function _debugOn() {
    if (window._LFJ_DEBUG_VAL === true)  return true;
    if (window._LFJ_DEBUG_VAL === false) return false;
    return !!(window.LF_CONFIG && window.LF_CONFIG.debug);
  }

  function _buildHUD() {
    if (_hud || typeof document === 'undefined' || !document.body) return;
    _hud = document.createElement('div');
    _hud.id = '__lfj-dbg-hud';
    _hud.setAttribute('aria-hidden','true');
    Object.assign(_hud.style, {
      position:'fixed', bottom:'0', left:'0', zIndex:'999999',
      maxWidth:'440px', maxHeight:'200px', overflowY:'auto',
      background:'rgba(0,0,0,0.9)', color:'#ff5555',
      fontFamily:'monospace', fontSize:'11px', lineHeight:'1.4',
      padding:'8px 10px', pointerEvents:'none', boxSizing:'border-box',
      borderTop:'1px solid rgba(255,85,85,0.5)',
      borderRight:'1px solid rgba(255,85,85,0.5)',
      borderRadius:'0 4px 0 0', whiteSpace:'pre-wrap', wordBreak:'break-all'
    });
    document.body.appendChild(_hud);
  }

  function _renderHUD() {
    if (!_hud) return;
    var items = window.__LFJ_ERRORS.slice(-5);
    if (!items.length) { _hud.textContent = '[LFJ DEBUG] No errors \u2713'; return; }
    _hud.textContent = items.map(function(e) {
      var t = new Date(e.time).toISOString().substr(11,8);
      return '[' + t + '] ' + e.kind + '\n  ' + (e.msg||'') +
             (e.src ? '\n  ' + e.src + (e.line ? ':'+e.line : '') : '');
    }).join('\n\u2500\n');
  }

  function _maybeUpdateHUD() {
    if (typeof document === 'undefined' || !document.body) return;
    if (!_debugOn()) {
      if (_hud) _hud.style.display = 'none';
      return;
    }
    if (!_hud) _buildHUD();
    if (_hud) { _hud.style.display = 'block'; _renderHUD(); }
  }

  /* Init HUD once DOM ready, re-check after LF_CONFIG loads */
  function _onReady(fn) {
    if (document.readyState !== 'loading') { fn(); return; }
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  }
  _onReady(function() {
    _maybeUpdateHUD();
    var n = 0;
    var poll = setInterval(function() {
      if (window.LF_CONFIG || ++n > 20) { clearInterval(poll); _maybeUpdateHUD(); }
    }, 150);
  });

  /* Live toggle: window.LFJ_DEBUG = true/false */
  Object.defineProperty(window, 'LFJ_DEBUG', {
    get: function() { return window._LFJ_DEBUG_VAL; },
    set: function(v) { window._LFJ_DEBUG_VAL = !!v; _maybeUpdateHUD(); },
    configurable: true
  });

}());
